module.exports = __webpack_public_path__ + "static/media/clemazon_g_cookie.57752bcc.png";